import React from 'react';
import { Controller } from 'react-hook-form';
import SwitchWithInfoIcon from '../SwitchWithInfoIcon';

/**
 * @param {import('@mui/material').SwitchProps & {
 *   label: string;
 *   info: string;
 *   inputRef?: import('react').RefCallback<SwitchWithInfoIcon>;
 *   onBlur?: any;
 *   onFocus?: any;
 *   color?: 'primary' | 'secondary' | 'default';
 *   checked?: boolean;
 *   name: string;
 *   control: any;
 *   rules?: any;
 * }} param0
 * @returns
 */
const FormSwitchWithInfo = ({
    name,
    control,
    rules,
    label,
    info = '',
    onChange: valueChanged,
    ...props
}) => (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
            field: {
                onBlur, onChange, value, ref,
            },
        }) => (
            <SwitchWithInfoIcon
                {...props}
                info={info}
                label={label}
                inputRef={ref}
                onBlur={onBlur}
                checked={value ?? false}
                onChange={(event, checked) => {
                    onChange(event);
                    if (valueChanged) {
                        valueChanged(event, checked);
                    }
                }}
            />
        )}
    />
);

export default FormSwitchWithInfo;
